import { DollarSign, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WhoBuys = ({ onOpenForm }) => (
  <section id="who-buys" className="py-20 md:py-24 bg-white" data-testid="who-buys-section">
    <div className="container-custom max-w-4xl">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 bg-[#EA580C]/10 text-[#EA580C] px-4 py-2 rounded-full text-sm font-semibold mb-6">
          <DollarSign className="w-4 h-4" />
          Local Diabetic Supply Buyer
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-6" style={{ fontFamily: "Manrope" }} data-testid="who-buys-h2">
          Who Buys Diabetic Test Strips in Jacksonville?
        </h2>
        <p className="text-lg md:text-xl text-[#4B5563] leading-relaxed max-w-2xl mx-auto">
          If you are asking, <span className="font-semibold text-[#1F2937]">who buys diabetic test strips</span>, we are your local solution. We make it easy to get cash for unused supplies safely.
        </p>
      </div>

      <div className="bg-[#F5F5F0] rounded-2xl p-8 md:p-10">
        <p className="text-base md:text-lg text-[#4B5563] leading-relaxed mb-6">
          As a trusted Jacksonville diabetic supply buyer, we work directly with sellers throughout Northeast Florida to purchase surplus, unopened test strips, CGM sensors, insulin pumps, and related supplies. Whether you inherited extra boxes, changed prescriptions, or simply have unused supplies sitting in a drawer, we turn them into instant cash the same day.
        </p>
        <p className="text-base md:text-lg text-[#4B5563] leading-relaxed mb-8">
          Skip the mail-in services with weeks of waiting. Text us a photo at <a href="tel:+19049559646" className="text-[#0F5132] font-semibold underline hover:text-[#0B3D25]" data-testid="who-buys-phone-link">(904) 955-9646</a> for an instant offer and same-day payment.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href="tel:+19049559646" data-testid="who-buys-call-link">
            <Button className="bg-[#0F5132] hover:bg-[#0B3D25] text-white rounded-full px-6 py-5 text-base font-semibold shadow-md w-full sm:w-auto" data-testid="who-buys-call-btn">
              <Phone className="w-4 h-4 mr-2" />
              Call (904) 955-9646
            </Button>
          </a>
          <a href="sms:+19049559646" data-testid="who-buys-sms-link">
            <Button variant="outline" className="rounded-full px-6 py-5 text-base font-medium border-2 border-[#EA580C] text-[#EA580C] hover:bg-[#EA580C]/5 w-full sm:w-auto" data-testid="who-buys-text-btn">
              <MessageCircle className="w-4 h-4 mr-2" />
              Text a Photo
            </Button>
          </a>
          <Button onClick={onOpenForm} className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-6 py-5 text-base font-semibold shadow-md" data-testid="who-buys-offer-btn">
            Get Your Offer
          </Button>
        </div>
      </div>
    </div>
  </section>
);
